<template>
  <a-drawer placement="right" :closable="false" :visible="showDrawer" @close="close" width="70%"
    :style="{ transform: 'none' }">
    <a-spin v-if="loading" size="large" class="loading" />
    <div v-else>
      <a class="close-img" @click="close" style="z-index: 999;">
        <img src="../../../../public/close.png" alt="" />
      </a>
      <div class="header" ref="headRef">
        <div class="title">
          {{ userId ? '修改老师' : '新建老师' }}
        </div>
      </div>
      <div>
        <div class="header" v-if="this.state.status === 2" style="justify-content: flex-start;padding-bottom: 12px;">
          <img class="pic1" referrerpolicy="no-referrer" src="/icon/reg/reject.png" />
          <div class="wrap1">
            <span class="word3">审核未通过</span>
            <span class="word4" style="display: block">不通过原因：{{ state.failReason }}</span>
            <span class="word4" style="display: block">审核时间：{{ state.failExamineDate }}</span>
            <span v-if="state.hasAttachment" class="word4" style="display: block">附件：{{ state.fileUrl }}
              <a @click="download" style="margin-left: 25px">下载</a></span>
          </div>
        </div>
        <a-form :form="form" style="padding: 25px 0 0 39px">
          <a-row :gutter="24">
            <!-- 基本资料 -->
            <div class="basics">
              <div class="section4">
                <div class="mod4"></div>
                <span class="txt1">基本资料</span>
              </div>
              <a-col :span="11">
                <div class="title">姓名</div>
                <a-form-item>
                  <a-input v-decorator="[
                    'nickname',
                    {
                      rules: [
                        {
                          pattern: /^.{2,10}$/,
                          message: '请输入长度为2~10位的负责人姓名',
                        },
                        { required: true, message: '请输入您的真实姓名' },
                      ],
                      initialValue: this.state.nickname,
                    },
                  ]" placeholder="请输入您的真实姓名" />
                </a-form-item>
              </a-col>
              <a-col :span="11">
                <div class="title">性别</div>
                <a-form-item>
                  <a-select v-decorator="[
                    'gender',
                    {
                      rules: [{
                        required: 'true',
                        message: '请选择'
                      }],
                      initialvalue: this.state.gender,
                    },
                  ]" placeholder="请选择您的性别">
                    <a-select-option value="1"> 男 </a-select-option>
                    <a-select-option value="2"> 女 </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="11">
                <div class="title">主要联络手机号</div>
                <a-form-item>
                  <a-input v-decorator="[
                    'mobile',
                    {
                      rules: [
                        {
                          pattern: /^1[3456789]\d{9}$/,
                          message: '请输入正确的手机号',
                        },

                        { required: true, message: '请输入您的手机号' },
                      ],
                      initialValue: this.state.mobile,
                    },
                  ]" placeholder="请输入您常用的手机号" :maxLength="11" />
                </a-form-item>
              </a-col>
              <a-col :span="11">
                <div class="title">身份证号</div>
                <a-form-item>
                  <a-input v-decorator="[
                    'cardNo',
                    {
                      rules: [
                        {
                          required: requiredSetting[10] && requiredSetting[10].settingValue == '1',
                          pattern:
                            /^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
                          message: '请输入正确的身份证号',
                        },
                      ],
                      initialValue: this.state.cardNo,
                    },
                  ]" placeholder="请输入您的身份证号" />
                </a-form-item>
              </a-col>
              <a-col :span="11">
                <div class="title">银行卡号</div>
                <a-form-item>
                  <a-input v-decorator="[
                    'bankCardNo',
                    {
                      rules: [
                        {
                          pattern: /^\d{16,19}$/,
                          message: '请输入正确的银行卡号',
                        },
                      ],

                      initialValue: this.state.bankCardNo,
                    },
                  ]" placeholder="请输入您常用的银行卡号" />
                </a-form-item>
              </a-col>
              <a-col :span="11">
                <div class="title">开户行</div>
                <a-form-item>
                  <a-input v-decorator="[
                    'bankName',
                    {
                      rules: [
                        {
                          pattern: /^.{1,45}$/,
                          message: '请输入45个字符以内的的开户行',
                        }],
                      initialValue: this.state.bankName,
                    },
                  ]" placeholder="请输入开户行" />
                </a-form-item>
              </a-col>
              <a-col :span="11">
                <div class="title">执教年限</div>
                <a-form-item>
                  <a-input-number :min="0" :max="100" style="width: 100%" v-decorator="[
                    'teachingYears',
                    {
                      initialValue: this.state.teachingYears,
                    },
                  ]" placeholder="请输入执教年限" />
                </a-form-item>
              </a-col>
              <a-col :span="11">
                <div class="title">授课方向</div>
                <a-form-item>
                  <a-input v-decorator="[
                    'applyCourseType',
                    {
                      rules: [
                        {
                          pattern: /^.{1,50}$/,
                          required: requiredSetting.length && requiredSetting[7].settingValue == '1',
                          message: '请输入50个字符以内的授课方向',
                        },
                      ],
                      initialValue: this.state.applyCourseType,
                    },
                  ]" placeholder="请输入授课方向" />
                </a-form-item>
              </a-col>

              <a-col :span="22">
                <div class="title">个人简介</div>
                <a-form-item>
                  <a-input type="textarea" class="textarea" v-decorator="[
                    'intro',
                  ]" placeholder="请简单介绍自己，多行输入" :auto-size="{
                    minRows: 5,
                    maxRows: 6,
                  }" :maxLength="2000" />
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item :required="true">
                  <div class="title">正面免冠照片（2寸）</div>
                  <c-upload accept="image/*" @uploadSuccess="uploadSuccess_fullFaced" class="fullFaced"
                    ref="protraitPhotoUrl" :isSingle="false" :maxlength="1" :maxFileSize="409600"
                    :imageMatchHeight="626" :imageMatchWidth="413" messageTitle="正面免冠照片"
                    :sourceFileList="sourceFileList_fullFaced"></c-upload>
                  <!-- 限制照片为两寸  :twoInches="true"-->
                  <div class="remark">
                    符合宽高413×626像素200KB以内，支持jpeg,jpg,png
                  </div>
                </a-form-item>
              </a-col>

              <a-col :span="8">
                <!-- --------------------------------------------------------------------- -->
                <a-form-item :required="true">
                  <div class="title" ref="avatarRef">头像</div>
                  <c-upload accept="image/*" @uploadSuccess="uploadSuccess_headPortrait" class="headPortrait"
                    :isSingle="false" :maxlength="1" :maxFileSize="1048576" ref="avatarUrl"
                    :sourceFileList="sourceFileList_avatarUrl"></c-upload>
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <!-- --------------------------------------------------------------------- -->
                <a-form-item :required="true">
                  <div class="title">8分钟说课视频（{{ requiredSetting.length &&
                    requiredSetting[3].settingValue == '1' ? '必' : '选' }}填）</div>
                  <div v-if="reqDesc.talkingVideoUrl">
                    <video style="height: 150px; width: 100%" controls="controls" muted="true"
                      :src="reqDesc.talkingVideoUrl"></video><a class="view-link" @click="uploadAgain" href="#">重新上传</a>
                  </div>
                  <c-upload v-if="sourceFileListTalkingVideoUrl.length == 0" accept="video/*" ossType="institution"
                    ref="uploadVideo" :maxlength="1" :showUploadList="false" messageTitle="说课视频" :isSingle="false"
                    @uploadSuccess="uploadVideo" :sourceFileList="sourceFileListTalkingVideoUrl"></c-upload>
                </a-form-item>
              </a-col>
              <a-col :span="24">
                <div class="section18"></div>
              </a-col>
            </div>
            <!-- 学历信息 -->
            <div class="information">
              <a-col :span="24">
                <div class="section4">
                  <div class="mod4"></div>
                  <span class="txt1">学历信息</span>
                </div>
              </a-col>
              <a-col :span="24">
                <div class="education">学历及毕业院校
                  <span class="require">({{ requiredSetting.length && (requiredSetting[0].settingValue
                    == '0' && requiredSetting[1].settingValue == '0') ? '选' : '必' }}填)</span>
                </div>
                <div class="education-rule" ref="educationRef">
                  *请上传所有高中以上学历
                </div>
              </a-col>
              <div class="xueli" v-for="(item, index) in state.degreeCertificatList" :key="index">
                <a-col :span="18" v-if="index !== 0">
                  <div class="outer9"></div>
                </a-col>
                <a-col :span="7">
                  <a-form-item>
                    <a-select v-decorator="[
                      `degreeCertificatList[${index}].eduBackground`,
                      {
                        rules: [{ required: requiredSetting.length && (requiredSetting[0].settingValue == '1' || requiredSetting[1].settingValue == '1'), message: '请选择您的学历' }],
                        initialValue: item.eduBackground || undefined,
                      },
                    ]" style="width: 150px" placeholder="请选择您的学历">
                      <a-select-option v-for="(item, index) in educationSelect" :key="index" :value="item">
                        {{ item }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :span="13">
                  <a-form-item>
                    <a-input v-decorator="[
                      `degreeCertificatList[${index}].text`,
                      {
                        rules: [{ required: requiredSetting.length && (requiredSetting[0].settingValue == '1' || requiredSetting[1].settingValue == '1') || form.getFieldValue(`degreeCertificatList[${index}].eduBackground`), message: '请输入您的毕业院校' }],
                        initialValue: item.text,
                      },
                    ]" placeholder="请输入毕业院校" />
                  </a-form-item>
                </a-col>

                <a-col :span="4" v-if="index !== 0">
                  <img src="/delete.png" style="width: 16px; height: 16px" alt="" />
                  <a-button class="btn" type="link" @click="deleteEducation(index)" style="margin-left: -4px">
                    删除</a-button>
                </a-col>
                <a-col :span="7" style="height: 25px">
                  <a-form-item :required="true">
                    <div class="card">学历证({{ requiredSetting.length &&
                      requiredSetting[0].settingValue == '1' ? '必' : '选' }}填)</div>
                    <c-upload accept="image/*" @uploadSuccess="uploadSuccess_diploma($event, index)" class="diploma"
                      :isSingle="false" :maxlength="1" ref="diploma" :sourceFileList="item.photoUrl2List"></c-upload>
                  </a-form-item>
                </a-col>
                <a-col :span="13">
                  <a-form-item :required="true">
                    <div class="card">学位证({{ requiredSetting.length &&
                      requiredSetting[1].settingValue == '1' ? '必' : '选' }}填)</div>
                    <c-upload accept="image/*" @uploadSuccess="uploadSuccess_photoUrl($event, index)" class="diploma"
                      :isSingle="false" :maxlength="1" ref="photoUrl" :sourceFileList="item.photoUrlList"></c-upload>
                  </a-form-item>
                </a-col>
              </div>
              <a-col :span="18">
                <a-form-item>
                  <a-button style="width: 365px; height: 42px" type="primary" ghost @click="addEducationInformation"
                    v-if="
                      !state.degreeCertificatList ||
                      state.degreeCertificatList.length < 5
                    ">
                    + 新增学历信息
                  </a-button>
                </a-form-item>
              </a-col>
              <a-col :span="24">
                <div class="section18"></div>
              </a-col>
            </div>
            <!-- 其他资料 -->

            <div class="attachments">
              <a-col :span="24">
                <div class="section4">
                  <div class="mod4"></div>
                  <span class="txt1">其他资料</span>
                </div>
              </a-col>
              <a-col :span="9">
                <a-form-item :required="true">
                  <div class="card" ref="IDCardRef">身份证（正面）</div>
                  <c-upload accept="image/*" :isSingle="false" :maxlength="1" class="frontIDCard"
                    @uploadSuccess="uploadSuccess_frontIDCard" ref="cardFrontUrl"
                    :sourceFileList="sourceFileList_cardFrontUrl"></c-upload>
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item :required="true">
                  <div class="card">身份证（反面）</div>
                  <c-upload accept="image/*" @uploadSuccess="uploadSuccess_backIDCard" class="backIDCard"
                    :isSingle="false" :maxlength="1" ref="cardBackUrl"
                    :sourceFileList="sourceFileList_cardBackUrl"></c-upload>
                </a-form-item>
              </a-col>
              <a-col :span="24">
                <a-form-item>
                  <div class="card">健康证明（{{ requiredSetting.length && requiredSetting[4].settingValue
                    == '1' ? '必' : '选' }}填,至多上传5张）</div>
                  <c-upload accept="image/*" @uploadSuccess="uploadSuccess_health" class="proveHealth" :isSingle="false"
                    :maxlength="5" ref="healthImgUrl" :sourceFileList="reqDesc.healthCertificateUrl"></c-upload>
                </a-form-item>
              </a-col>
              <a-col :span="24">
                <a-form-item>
                  <div class="card">老师资质证书（{{ requiredSetting.length &&
                    requiredSetting[6].settingValue
                    == '1' ? '必' : '选' }}填,至多上传5张）</div>
                  <c-upload accept="image/*" @uploadSuccess="uploadSuccess_teacher" class="proveHealth"
                    :isSingle="false" :maxlength="5" ref="qualification"
                    :sourceFileList="reqDesc.credentialInfoUrlList"></c-upload>
                </a-form-item>
              </a-col>
              <a-col :span="9">
                <a-form-item>
                  <div class="card">无犯罪记录证明（{{ requiredSetting.length &&
                    requiredSetting[2].settingValue == '1' ? '必' : '选' }}填）</div>
                  <c-upload accept="image/*" @uploadSuccess="uploadSuccess_criminal" class="prove" :isSingle="false"
                    :maxlength="1" ref="noCrimeImgUrl" :sourceFileList="sourceFileList_noCriminalUrl"></c-upload>
                </a-form-item>
              </a-col>
              <a-col :span="7">
                <a-form-item>
                  <div class="card">无犯罪记录证明有效期（{{ requiredSetting.length &&
                    requiredSetting[9].settingValue == '1' ? '必' : '选' }}填）</div>
                  <a-date-picker @change="noCriminalDateChange" v-decorator="[
                    'noCriminalExpiryDate',
                    {
                      rules: [
                        {
                          required: requiredSetting.length && requiredSetting[9].settingValue == '1',
                          message: '请选择无犯罪记录证明有效期',
                        },
                      ],
                      initialValue: this.state.noCriminalExpiryDate,
                    },
                  ]" />
                </a-form-item>
              </a-col>
              <a-col :span="24">
                <a-form-item>
                  <div class="card">从业经验（{{ requiredSetting.length && requiredSetting[8].settingValue
                    == '1' ? '必' : '选' }}填,至多上传5张）</div>
                  <c-upload accept="image/*" @uploadSuccess="uploadSuccess_experience" class="proveHealth"
                    :isSingle="false" ref="experienceUrl" :maxlength="5"
                    :sourceFileList="reqDesc.experience"></c-upload>
                </a-form-item>
              </a-col>
            </div>
          </a-row>
          <div class="section27"></div>
          <div class="footer">
            <a-button class="button" type="primary" ghost @click="close">
              取消
            </a-button>
            <a-button @click="submit(0)" class="button" type="primary" html-type="submit">
              保存
            </a-button>
            <a-button @click="submit(1)" class="button" type="primary" html-type="submit" v-if="showBtn">
              保存并提交审核
            </a-button>
          </div>
        </a-form>
      </div>
    </div>
  </a-drawer>
</template>

<script>
import teacher from '../../../api/teacher'
import bureau from '../../../api/bureau'
import CUpload from '../../../components/CUpload'

import school from '../../../api/school'

import moment from 'moment'
export default {
  name: "SchoolTeacherForm",
  props: {
    showDrawer: {
      type: Boolean,
      default: false,
    },
    userId: {
      type: Number,
    },
  },
  data() {
    return {
      loading: false,
      form: this.$form.createForm(this),
      state: {
        gender: 1,
        intro: '',
        degreeCertificatList: [
          {
            photoUrl: '',
            photoUrlList: [],
            text: '',
            eduBackground: '',
            photoUrl2: '',
            photoUrl2List: []
          }
        ],
      },
      reqDesc: {
        protraitPhotoUrl: '',
        cardFrontUrl: '',
        cardBackUrl: '',
        avatarUrl: '',
        healthCertificateUrl: [],
        noCriminalUrl: '',
        credentialInfoUrlList: [],
        experience: [],
        talkingVideoUrl: '',
      },
      educationSelect: ['专科', '本科', '研究生', '博士', '其他'],
      addCount: 0,
      sourceFileList: [],
      bureauId: '',
      loading: false,
      status: 0,
      sourceFileList_cardBackUrl: [],
      sourceFileList_cardFrontUrl: [],
      sourceFileList_fullFaced: [],
      sourceFileList_avatarUrl: [],
      sourceFileList_noCriminalUrl: [],
      sourceFileListTalkingVideoUrl: [],
      requiredSetting: [],
      showBtn: false
    }
  },
  components: {
    CUpload
  },
  created() {
    this.init()
    this.getBtnStatus()

  },
  mounted() {
  },
  methods: {
    getBtnStatus() {
      this.showBtn = this.$ls.get('teaBureauSetting').find(item => item.settingKey == 'school_teacher_status').settingValue == '1' ? true : false
    },
    init(id) {
      this.getTeacherRequiredFields()
      bureau.getBureauId().then((res) => {
        this.bureauId = res
      })
      if (id) {
        this.getTeacherInfo(id)
      }
    },
    backTop() {
      this.$nextTick(() => {
        this.$refs.headRef.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      })
    },
    getTeacherInfo(id) {
      teacher.getTeacherDetail({ userId: id }).then(res => {
        // this.state = res.data
        this.dataBack(res.data)
        this.state.status = res.data.status
        this.state.failReason = res.data.failReason
        this.state.failExamineDate = res.data.failExamineDate
        this.state.fileUrl = res.data.fileUrl
        this.state.nickname = res.data.nickname
        this.state.mobile = res.data.mobile
        this.state.cardNo = res.data.cardNo
        this.state.gender = res.data.gender
        this.state.bankCardNo = res.data.bankCardNo
        this.state.bankName = res.data.bankName
        this.state.teachingYears = res.data.teachingYears
        this.state.hasAttachment = res.data.hasAttachment
        if (res.data.noCrimeExpiryDate && res.data.noCrimeExpiryDate[0].text !== 'null') {
          this.state.noCriminalExpiryDate = moment(res.data.noCrimeExpiryDate[0].text)
        }
      })
    },
    getTeacherRequiredFields() {
      school.getTeacherRequiredFields({ type: 1 }).then(res => {
        this.requiredSetting = res.data.settingKeyValueDTOS
      })
    },
    download() {
      teacher.getFile()
    },
    uploadAgain() {
      this.reqDesc.talkingVideoUrl = null
      this.sourceFileListTalkingVideoUrl.pop()
    },
    //删除学历按钮
    deleteEducation(i) {
      this.state.degreeCertificatList = this.state.degreeCertificatList.filter(
        (item, index) => i !== index
      )
      this.addCount = this.state.degreeCertificatList.length - 1

      this.disabledSelect(this.state.degreeCertificatList)
    },
    // 无犯罪记录证明有效期改变
    noCriminalDateChange(e) {
      this.state.noCriminalExpiryDate = moment(e && e._d).format('YYYY-MM-DD')
    },
    //数据回显
    dataBack(data) {
      // this.state = { ...data }

      if (data.fileUrl) {
        let a = /ware\-[0-9a-fA-F]{32}\_(.+)/gi.exec(data.fileUrl)
        let b = data.fileUrl.split('/')
        if (a[1]) {
          data.fileUrl = a[1]
        } else {
          data.fileUrl = b[b.length - 1]
        }
      }
      if (data.degreeCertificatList && data.degreeCertificatList.length) {
        data.degreeCertificatList = data.degreeCertificatList
          .map((item) => {
            /**
             * 1 是学位
             */
            const photoUrlList = item.teaTeacherInfoDos.filter(
              (item) => item.extType === 1
            ).map(i => i.fileUrl)
            const photoUrl = photoUrlList.length ? photoUrlList[0] : ''
            /**
             * 0 是学历
             */
            const photoUrl2List = item.teaTeacherInfoDos.filter(
              (item) => item.extType === 0
            ).map(i => i.fileUrl)
            const photoUrl2 = photoUrl2List.length
              ? photoUrl2List[0]
              : ''
            return {
              eduBackground: item.description,
              text: item.text,
              photoUrl,
              photoUrlList,
              photoUrl2,
              photoUrl2List
            }
          })
          .filter((item) => {
            return item.photoUrl || item.photoUrl2 || item.text
          })
      } else {
        data.degreeCertificatList = [{
          photoUrl: '',
          photoUrlList: [],
          text: '',
          eduBackground: '',
          photoUrl2: '',
          photoUrl2List: []
        }]
      }

      this.state.degreeCertificatList = data.degreeCertificatList

      // console.log('data', data)
      if (data.gender == 2) {
        this.form.setFieldsValue({ gender: '女' })
      } else if (data.gender == 1) {
        this.form.setFieldsValue({ gender: '男' })
      }
      if (data.intro == 'undefined') {
        this.state.intro = ''
      } else {
        this.form.setFieldsValue({ intro: data.intro })
      }
      if (data.applyCourseType == 'undefined') {
        this.state.applyCourseType = ''
      } else {
        this.form.setFieldsValue({ applyCourseType: data.applyCourseType })
      }
      if (data.cardBackUrl) {
        this.sourceFileList_cardBackUrl.push(data.cardBackUrl) //身份证反面
        this.state.cardBackUrl = data.cardBackUrl
      }
      if (data.cardFrontUrl) {
        this.sourceFileList_cardFrontUrl.push(data.cardFrontUrl) //身份证正面
        this.state.cardFrontUrl = data.cardFrontUrl
      }
      if (data.protraitPhotoUrl) {
        this.sourceFileList_fullFaced.push(data.protraitPhotoUrl[0].fileUrl) //证件照
        this.state.protraitPhotoUrl = data.protraitPhotoUrl
      }
      if (data.avatarUrl) {
        this.sourceFileList_avatarUrl.push(data.avatarUrl) //头像
        this.state.avatarUrl = data.avatarUrl
      }
      if (data.talkingVideoUrl) {
        this.reqDesc.talkingVideoUrl = data.talkingVideoUrl[0].fileUrl
        this.sourceFileListTalkingVideoUrl.push(data.talkingVideoUrl[0].fileUrl) //8分钟说课视频
      }
      if (data.healthCertificateUrl && data.healthCertificateUrl.length !== 0) {
        this.reqDesc.healthCertificateUrl = data.healthCertificateUrl.map(
          (item) => {
            return item.fileUrl
          }
        ) //健康证明
      }
      if (data.credentialInfoUrl && data.credentialInfoUrl.length !== 0) {
        this.reqDesc.credentialInfoUrlList = data.credentialInfoUrl.map((item) => {
          return item.fileUrl
        }) //老师资质
      }
      if (data.noCriminalUrl) {
        this.sourceFileList_noCriminalUrl.push(data.noCriminalUrl[0].fileUrl) //无犯罪记录
        this.state.noCriminalUrl = data.noCriminalUrl
      }
      if (data.experience && data.experience.length !== 0) {
        this.reqDesc.experience = data.experience.map((item) => {
          return item.fileUrl
        }) //从业经验
      }
    },
    //新增学历
    addEducationInformation() {
      this.form.validateFieldsAndScroll(['degreeCertificatList'], (err, values) => {
        if (!err && this.requiredSetting[0].settingValue == '0' && this.requiredSetting[1].settingValue == '0') {
          let current = values.degreeCertificatList[values.degreeCertificatList.length - 1]
          if (!current.eduBackground && !current.text) return this.$message.warning('请完善学历信息中的上一项')
          this.state.degreeCertificatList.push({
            photoUrl: '',
            photoUrlList: [],
            text: '',
            eduBackground: '',
            photoUrl2: '',
            photoUrl2List: [],
          })
          this.disabledSelect(values.degreeCertificatList)
          this.addCount += 1
          return
        } else if (!err && this.requiredSetting[0].settingValue == '1' && this.state.degreeCertificatList[this.addCount].photoUrl2) {
          this.$refs.diploma[this.addCount].check()
          if (this.requiredSetting[1].settingValue == '1') {
            this.$refs.photoUrl[this.addCount].check()
            if (!this.state.degreeCertificatList[this.addCount].photoUrl) return
          }
          this.state.degreeCertificatList.push({
            photoUrl: '',
            photoUrlList: [],
            text: '',
            eduBackground: '',
            photoUrl2: '',
            photoUrl2List: [],
          })
          this.disabledSelect(values.degreeCertificatList)
          this.addCount += 1
        } else if (!err && this.requiredSetting[1].settingValue == '1' && this.state.degreeCertificatList[this.addCount].photoUrl) {
          this.$refs.photoUrl[this.addCount].check()
          if (this.requiredSetting[0].settingValue == '1') {
            this.$refs.diploma[this.addCount].check()
            if (!this.state.degreeCertificatList[this.addCount].photoUrl2) return
          }
          this.state.degreeCertificatList.push({
            photoUrl: '',
            photoUrlList: [],
            text: '',
            eduBackground: '',
            photoUrl2: '',
            photoUrl2List: [],
          })
          this.disabledSelect(values.degreeCertificatList)
          this.addCount += 1
        } else {
          if (this.requiredSetting[0].settingValue == '1') this.$refs.diploma[this.addCount].check()
          if (this.requiredSetting[1].settingValue == '1') this.$refs.photoUrl[this.addCount].check()
        }
      })
    },
    // 校验学历信息有图片时，背景和院校是否填写
    checkEdu(){
      let first = this.form.getFieldsValue().degreeCertificatList[0]
      if(this.state.degreeCertificatList.find(item => item.photoUrl || item.photoUrl2)){
        if(!first.eduBackground || !first.text){
          this.$message.warning('请完善学历信息中的第一项')
          this.$refs.educationRef.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
          return false
        }
      }
      return true
    },
    //提交
    submit(type) {
      if(!this.checkEdu()) return
      // 教育局需要审核，仅保存时
      if (this.showBtn && type == 0) {
        this.form.validateFieldsAndScroll(['mobile','gender','nickname'], (err, values) => {
          if(!err){
            const values2 = this.form.getFieldsValue()
            this.handleSubmit(values2, type)
          }
        })
        return
      }
      this.form.validateFieldsAndScroll((err, values) => {
        this.checkoutPerson(err).then(async (res) => {
          if (!err && res === true) {
            this.handleSubmit(values, type)
          }
        })
      })
    },
    handleSubmit(values, type) {
      let arr = []
      this.state.degreeCertificatList.map((item, index) => {
        if(values.degreeCertificatList && values.degreeCertificatList.length){
          values.degreeCertificatList.map((i, v) => {
          if (index === v) {
            arr.push({ ...item, ...i })
            return arr
          }
        })
        }
      })
      arr.forEach((item,index) => {
        console.log(item,'item',item.length)
        for (let k in item){
          if(!item[k] || !item[k].length){
            delete item[k]
          }
        }
        if(!item.eduBackground || !item.text) {
          arr.splice(index,1)
        }
      })
      console.log(arr,123)
      let credentialInfoUrlDemo = []
      if (this.reqDesc.credentialInfoUrlList.length !== 0) {
        credentialInfoUrlDemo = this.reqDesc.credentialInfoUrlList
      }
      let experienceDemo = []
      if (this.reqDesc.experience.length !== 0) {
        experienceDemo = this.reqDesc.experience
      }

      const data = {
        ...this.state,
        ...values,
        degreeCertificatListString: arr.length? JSON.stringify(arr) : null,
        ...this.reqDesc,
        bureauId: this.bureauId,
        gender: this.state.gender ? this.state.gender : values.gender,
        cardFrontUrl:
          this.reqDesc.cardFrontUrl || this.state.cardFrontUrl,
        cardBackUrl: this.reqDesc.cardBackUrl || this.state.cardBackUrl,
        protraitPhotoUrl:
          this.reqDesc.protraitPhotoUrl ||
          (this.state.protraitPhotoUrl &&
            this.state.protraitPhotoUrl[0].fileUrl),
        avatarUrl: this.reqDesc.avatarUrl || this.state.avatarUrl,
        noCriminalUrl:
          this.reqDesc.noCriminalUrl ||
          (this.state.noCriminalUrl &&
            this.state.noCriminalUrl[0].fileUrl),
        credentialUrl: credentialInfoUrlDemo.join(';'),
        experience: experienceDemo
      }
      if (data.noCriminalExpiryDate) {
        data.noCriminalExpiryDate = moment(this.state.noCriminalExpiryDate).format('YYYY-MM-DD')
      }
      delete data.degreeCertificatList
      delete data.credentialInfoUrlList
      for (let key in data) {
        if (data[key] == undefined) {
          data[key] = ''
        }
      }
      if (this.userId) {
        this.updateTeacher(data, type)
      } else {
        this.addTeacher(data, type)
      }
    },
    //新增老师
    addTeacher(data, type) {
      const newParams = data
      newParams.cardBackUrl = this.reqDesc.cardBackUrl
      newParams.cardFrontUrl = this.reqDesc.cardFrontUrl
      if (type) {
        newParams.saveType = 1
      } else {
        newParams.saveType = this.showBtn ? 0 : 1
      }
      // console.log(newParams)
      teacher.addTeacher(newParams).then((res) => {
        this.$message.success('新增成功')
        this.close('finish')
        this.$emit('refresh')
      })
    },
    //修改老师
    updateTeacher(data, type) {
      const newParams = data
      if (type) {
        newParams.saveType = 1
      } else {
        newParams.saveType = this.showBtn ? 0 : 1
      }
      // console.log(newParams)
      teacher.updateTeacher(this.userId, newParams).then((res) => {
        this.$message.success('修改成功')
        this.close('finish')
        this.$emit('refresh')
      })
    },
    //校验
    checkoutPerson(err) {
      return new Promise((resolve) => {
        let qualificationFlag
        let degreeFlag
        this.state.degreeCertificatList.forEach((item, index) => {
          if (this.requiredSetting[0].settingValue == '0') return qualificationFlag = true
          this.$refs.diploma[index].check()
          return qualificationFlag = !item.photoUrl2 ? false : true
        })
        this.state.degreeCertificatList.forEach((item, index) => {
          if (this.requiredSetting[1].settingValue == '0') return degreeFlag = true
          this.$refs.photoUrl[index].check()
          return degreeFlag = !item.photoUrl ? false : true
        })
        Promise.all([
          this.requiredSetting[5].settingValue == '1' ? this.$refs.protraitPhotoUrl.check() : true, // 免冠照
          true,
          qualificationFlag, // 学历
          degreeFlag, // 学位
          this.requiredSetting[10].settingValue == '1' ? this.$refs.cardFrontUrl.check() : true, // 身份证正面
          this.requiredSetting[10].settingValue == '1' ? this.$refs.cardBackUrl.check() : true, // 身份证反面
          this.requiredSetting[4].settingValue == '1' ? this.$refs.healthImgUrl.check() : true, // 健康证明
          this.requiredSetting[6].settingValue == '1' ? this.$refs.qualification.check() : true, // 师资
          this.requiredSetting[2].settingValue == '1' ? this.$refs.noCrimeImgUrl.check() : true, // 无犯罪记录证明
          this.requiredSetting[8].settingValue == '1' ? this.$refs.experienceUrl.check() : true, // 从业经验
        ]).then((res) => {
          // console.log('res1', res)
          let res1 = res.every((item) => item === true)
          resolve(res1)
          if (err) return
          if ((!res[0])) {
            this.$refs.avatarRef.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
            return
          }
          if (!res[2] || !res[3]) {
            this.$refs.educationRef.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
            return
          }
          if ((!res[4] || !res[5])) {
            this.$refs.IDCardRef.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
          }
          if (!res[6]) {
            this.$refs.healthImgRef.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
            return
          }
        })
      })
    },
    //学历下拉框
    disabledSelect(values) {
      // console.log('disabledSelectvalues', values)
      let educationSelect = ['专科', '本科', '研究生', '博士', '其他']
      this.educationSelect = educationSelect.filter(
        (item) => !values.map((item) => item.eduBackground).includes(item)
      )
    },
    //正面免冠照片
    uploadSuccess_fullFaced(url) {
      if (!url.length) {
        this.reqDesc.protraitPhotoUrl = ''
        if (this.state.protraitPhotoUrl[0]) {
          this.state.protraitPhotoUrl[0].fileUrl = ''
        } else {
          this.state.protraitPhotoUrl = []
        }
      }
      // console.log('url', url)
      if (url.length > 0) {
        this.reqDesc.protraitPhotoUrl = url[0].url
      }
    },
    //头像
    uploadSuccess_headPortrait(url) {
      if (!url.length) {
        this.reqDesc.avatarUrl = ''
        this.state.avatarUrl = ''
      }
      if (url.length > 0) {
        this.reqDesc.avatarUrl = url[0].url
      }
    },
    //学历证
    uploadSuccess_diploma(url, index) {
      if (url.length > 0) {
        this.state.degreeCertificatList[index].photoUrl2 = url[0].url
      } else {
        this.state.degreeCertificatList[index].photoUrl2 = ''
      }
    },
    //学位证
    uploadSuccess_photoUrl(url, index) {
      if (url.length > 0) {
        this.state.degreeCertificatList[index].photoUrl = url[0].url
      } else {
        this.state.degreeCertificatList[index].photoUrl = ''
      }
    },
    //身份证正面
    uploadSuccess_frontIDCard(url) {
      if (!url.length) {
        this.reqDesc.cardFrontUrl = ''
        this.state.cardFrontUrl = ''
      }
      if (url.length > 0) {
        this.reqDesc.cardFrontUrl = url[0].url
      }
    },
    //身份证反面
    uploadSuccess_backIDCard(url) {
      if (!url.length) {
        this.reqDesc.cardBackUrl = ''
        this.state.cardBackUrl = ''
      }
      if (url.length > 0) {
        this.reqDesc.cardBackUrl = url[0].url
      }
    },
    //健康证明
    uploadSuccess_health(list) {
      let arr = []
      list.map((item) => {
        arr.push(item.url)
        return arr
      })
      this.reqDesc.healthCertificateUrl = arr
    },
    //无犯罪记录证明
    uploadSuccess_criminal(url) {
      if (!url.length) {
        this.reqDesc.noCriminalUrl = ''
        this.state.noCriminalUrl[0].fileUrl = ''
      }
      if (url.length > 0) {
        this.reqDesc.noCriminalUrl = url[0].url
      }
    },
    //老师资质
    uploadSuccess_teacher(list) {
      let arr = []
      list.map((item) => {
        arr.push(item.url)
        return arr
      })
      this.reqDesc.credentialInfoUrlList = arr
    },
    //从业经验
    uploadSuccess_experience(list) {
      let arr = []
      list.map((item) => {
        arr.push(item.url)
        return arr
      })
      this.reqDesc.experience = arr
    },
    //8分钟说课视频
    uploadVideo(list) {
      this.reqDesc.talkingVideoUrl = list[list.length - 1].url
      this.sourceFileListTalkingVideoUrl.push(this.reqDesc.talkingVideoUrl)
    },

    haveChanged() {
      let formData = this.form.getFieldsValue()
      for (let k in formData) {
        if (k == 'degreeCertificatList') {
          formData[k].forEach(item => {
            for (let k2 in item) {
              if (item[k2] != undefined) {
                return true
              }
            }
          })
        } else {
          if (formData[k] != undefined) {
            return true
          }
        }
      }
      return false
    },
    close(flag) {
      if (this.haveChanged() && flag !== 'finish') {
        let _this = this
        this.$confirm({
          title: "提示",
          content: "您编辑的信息暂未保存，是否继续退出？",
          okText: "确定",
          cancelText: "取消",
          onOk: () => {
            _this.$emit("update:showDrawer", false);
            _this.clearData();
          },
          onCancel: () => {
            return;
          },
        });
      } else {
        this.$emit("update:showDrawer", false);
        this.clearData();
      }
    },
    clearData() {
      this.form.resetFields()
      this.state = {
        gender: 1,
        intro: '',
        degreeCertificatList: [
          {
            photoUrl: '',
            photoUrlList: [],
            text: '',
            eduBackground: '',
            photoUrl2: '',
            photoUrl2List: []
          }
        ],
      }
      this.reqDesc = {
        protraitPhotoUrl: '',
        cardFrontUrl: '',
        cardBackUrl: '',
        avatarUrl: '',
        healthCertificateUrl: [],
        noCriminalUrl: '',
        credentialInfoUrlList: [],
        experience: [],
        talkingVideoUrl: '',
      }
      this.sourceFileList_cardBackUrl = []
      this.sourceFileList_cardFrontUrl = []
      this.sourceFileList_fullFaced = []
      this.sourceFileList_avatarUrl = []
      this.sourceFileList_noCriminalUrl = []
      this.sourceFileListTalkingVideoUrl = []
    }
  },
}
</script>

<style lang="scss" scoped>
::v-deep .ant-drawer-body {
  font-family: PingFangSC, PingFang SC;
  padding: 0;
}

.ant-row {
  width: 100%;
}

::v-deep .ant-divider {
  margin: 10px 0;
  background-color: #f0f3fb !important;
}

.close-img {
  position: absolute;
  top: 20px;
  right: 26px;
}

.loading {
  height: 100vh;
  width: 100%;
  padding-top: 35%;
}

.header {
  // position: relative;
  top: 0;
  z-index: 999;
  background: #F1F6FC;
  height: 64px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 70px 0 24px;

  .title {
    font-weight: 600;
    font-size: 16px;
    color: #1B1D26;
  }

  .wrap1 {
    margin-left: 24px;
  }
}

.section4 {
  z-index: auto;
  height: 22px;
  margin-bottom: 39px;
}

.mod4 {
  z-index: 79;
  width: 9px;
  height: 20px;
  border-radius: 4.5px 4.5px 4.5px 4.5px;
  background-color: rgba(78, 148, 255, 1);
  margin-top: 1px;
  display: inline-block;
}

.txt1 {
  z-index: 65;
  width: 80px;
  height: 22px;
  display: inline-block;
  overflow-wrap: break-word;
  color: rgba(78, 148, 255, 1);
  font-size: 20px;
  font-family: PingFangSC-Medium;
  line-height: 22px;
  text-align: left;
  vertical-align: top;
  margin-left: 12px;
}

.title {
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.85);
}

.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.education {
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.85);
}

.education-rule {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ff7032;
  margin-bottom: 20px;
}

.section18 {
  z-index: 38;
  width: 100%;
  height: 4px;
  background-color: rgba(248, 248, 248, 1);
  align-self: center;
  margin: 10px 0;
}

.card {
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.85);
}

.section27 {
  height: 0px;
  padding-bottom: 88px;
}

.button {
  width: 140px;
  height: 42px;
  margin-left: 24px;
}

.footer {
  position: fixed;
  bottom: 0;
  display: flex;
  justify-content: center;
  background-color: #fff;
  border-top: 1px solid #f8f8f8;
  width: 60vw;
  z-index: 100;
  padding: 23px 0;
}

.remark {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #87888a;
  line-height: 20px;
}

/deep/ .fullFaced .ant-upload {
  width: 160px;
  height: 242px;
  border: 0;

  .ant-upload-text {
    display: none;
  }

  .ant-spin {
    width: 50%;
    height: 94%;
  }
}

/deep/ .fullFaced .ant-spin-nested-loading {
  width: 160px;
}

//背景图
/deep/ .backgroundImage .ant-upload {
  width: 750px;
  height: 250px;
  border: 0;

  .ant-upload-text {
    display: none;
  }

  .ant-spin {
    width: 50%;
    height: 94%;
  }
}

/deep/ .backgroundImage .ant-spin-nested-loading {
  width: 750px;
}

/deep/ .backgroundImage .ant-upload-list-picture-card-container {
  width: 750px;
  height: 250px;
  border: 0;
}

/deep/ .backgroundImage .ant-upload-list-item {
  width: 750px;
  height: 250px;
  border: 0;
}

/deep/ .certificateUrl .ant-spin-nested-loading {
  width: 297px;
}

/deep/ .certificateUrl .ant-upload {
  width: 297px;
  height: 210px;
  border: 0;

  .ant-upload-text {
    display: none;
  }

  .ant-spin {
    width: 50%;
    height: 94%;
  }

  .ant-spin-nested-loading {
    width: 297px;
  }
}

/deep/ .schoolPermit .ant-upload {
  width: 297px;
  height: 210px;
  border: 0;

  .ant-upload-text {
    display: none;
  }

  .ant-spin {
    width: 50%;
    height: 94%;
  }
}

/deep/ .schoolPermit .ant-spin-nested-loading {
  width: 297px;
}

//头像
/deep/ .headPortrait .ant-upload {
  width: 160px;
  height: 160px;
  border: 0;

  .ant-upload-text {
    display: none;
  }
}

/deep/ .headPortrait .ant-spin-nested-loading {
  width: 160px;
}

//LOGO
/deep/ .LOGO .ant-upload {
  width: 250px;
  height: 250px;
  border: 0;

  .ant-upload-text {
    display: none;
  }
}

/deep/ .LOGO .ant-spin-nested-loading {
  width: 250px;
}

/deep/ .LOGO .ant-upload-list-picture-card-container {
  width: 250px;
  height: 250px;
  border: 0;
}

/deep/ .LOGO .ant-upload-list-item {
  width: 250px;
  height: 250px;
  border: 0;
}

/deep/ .diploma .ant-upload {
  width: 160px;
  height: 160px;
  border: 0;

  .ant-upload-text {
    display: none;
  }
}

/deep/ .diploma .ant-spin-nested-loading {
  width: 160px;
}

/deep/ .frontIDCard .ant-upload {
  width: 320px;
  height: 200px;
  border: 0;
  background: url(/home/frontIDCard.png) no-repeat center;
  background-size: 100% 100%;

  .ant-upload-text {
    display: none;
  }

  .anticon-plus {
    display: none;
  }

  .ant-spin-nested-loading>div>.ant-spin .ant-spin-dot {
    left: 33%;
  }
}

/deep/ .backIDCard .ant-upload {
  width: 320px;
  height: 200px;
  border: 0;
  margin-left: 0px;
  background: url(/home/backIDCard.png) no-repeat center;
  background-size: 100% 100%;

  .ant-upload-text {
    display: none;
  }

  .anticon-plus {
    display: none;
  }
}

/deep/ .prove .ant-upload {
  width: 160px;
  height: 160px;
  border: 0;

  .ant-upload-text {
    display: none;
  }
}

/deep/ .prove .ant-spin-nested-loading {
  width: 160px;
}

/deep/ .otherMaterialsUrls .ant-upload {
  width: 160px;
  height: 160px;
  border: 0;

  .ant-upload-text {
    display: none;
  }
}

/deep/ .proveHealth .ant-upload {
  width: 160px;
  height: 160px;
  border: 0;

  /deep/ .ant-upload-list-item-list-type-picture-card {
    width: 160px;
    height: 160px;
    border: 0;
  }

  /deep/ .ant-upload-list-item {
    width: 160px;
    height: 160px;
    border: 0;
  }

  .ant-upload-text {
    display: none;
  }
}

/deep/ .ant-upload-list-picture-card-container {
  width: 160px;
  height: 160px;
  border: 0;
}

/deep/ .ant-upload-list-item {
  width: 160px;
  height: 160px;
  border: 0;
}

/deep/ .fullFaced .ant-upload-list-item {
  width: 160px;
  height: 242px;
  border: 0;
}

/deep/ .fullFaced .ant-upload-list-picture-card-container {
  width: 160px;
  height: 242px;
  border: 0;
}

/deep/ .certificateUrl .ant-upload-list-picture-card-container {
  width: 297px;
  height: 210px;
  border: 0;
}

/deep/ .certificateUrl .ant-upload-list-item {
  width: 297px;
  height: 210px;
  border: 0;
}

/deep/ .schoolPermit .ant-upload-list-picture-card-container {
  width: 297px;
  height: 210px;
  border: 0;
}

/deep/ .certificateUrl .ant-spin-nested-loading {
  width: 297px;
}

/deep/ .schoolPermit .ant-upload-list-item {
  width: 297px;
  height: 210px;
  border: 0;
}

/deep/ .otherMaterialsUrls .ant-upload-list-picture-card-container {
  width: 160px;
  height: 160px;
  border: 0;
}

/deep/ .otherMaterialsUrls .ant-upload-list-item {
  width: 160px;
  height: 160px;
  border: 0;
}

/deep/ .otherMaterialsUrls .ant-upload-picture-card-wrapper {
  width: 100%;
}

/deep/ .frontIDCard .ant-upload-list-item {
  width: 320px;
  height: 200px;
  border: 0;
}

/deep/ .frontIDCard .ant-spin-nested-loading {
  width: 320px;
}

/deep/ .frontIDCard .ant-upload-list-picture-card-container {
  width: 160px;
  height: 242px;
  border: 0;
}

/deep/ .backIDCard .ant-upload-list-item {
  width: 320px;
  height: 200px;
  border: 0;
}

/deep/ .backIDCard .ant-spin-nested-loading {
  width: 320px;
}

/deep/ .backIDCard .ant-upload-list-picture-card-container {
  width: 160px;
  height: 242px;
  border: 0;
}

/deep/ .btn {
  width: 36px;
  height: 25px;
  font-size: 17px;
  margin-top: 10px;
  vertical-align: bottom;
}

.outer9 {
  z-index: 37;
  width: 130%;
  height: 1px;
  // background-color: #000;
  background-color: #f8f8f8;
  margin-top: 20px;
  margin-bottom: 20px;
}

.title {
  text-align: left;
}

.require {
  padding-left: 5px;
  color: red;
  font-size: 14px;
  font-weight: 400;
}

.textarea {
  resize: none;
}
</style>